import apiClient from '@/services/rest-api-sms/apiClient'
const baseEndpoint = '/vss-configuration'

export const get = async (queryParam, serverRegion) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
    headers: {
      'X-Region': serverRegion,
    },
  })

  return response?.data
}

export const patch = async (id, payload) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data: payload,
  })

  return response?.data
}

export const create = async (id, payload) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/${id}`,
    data: payload,
  })

  return response?.data
}

export const createProfile = async (payload, serverRegion) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}`,
    data: payload,
    headers: {
      'X-Region': serverRegion,
    },
  })

  if (response.data?.status >= 400) {
    throw new Error(response.data?.data?.message)
  }

  return response?.data
}

export const updateProfile = async (id, payload, serverRegion) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data: payload,
    headers: {
      'X-Region': serverRegion,
    },
  })

  if (response.data?.status >= 400) {
    throw new Error(response.data?.data?.message)
  }

  return response?.data
}

export const deleteProfile = async (payload, serverRegion) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}`,
    headers: {
      'X-Region': serverRegion,
    },
    data: payload,
  })
  
  if (response.data?.status >= 400) {
    throw new Error(response.data?.data?.message)
  }

  return response?.data
}

export const getProfiles = async (queryParam, serverRegion) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
    headers: {
      'X-Region': serverRegion,
    },
  })

  return response?.data
}
